import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "dateLabel" }
const _hoisted_2 = { class: "filter-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_ButtonBlue = _resolveComponent("ButtonBlue")!
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('preventif.suivi.modal.equipment.input.label.period')), 1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_DatePicker, {
        class: "datepicker",
        onSetDate: _ctx.setFilterDateDebut,
        dateValue: _ctx.dateDebut,
        label: _ctx.$t('start.date')
      }, null, 8, ["onSetDate", "dateValue", "label"]),
      _createVNode(_component_DatePicker, {
        class: "datepicker",
        onSetDate: _ctx.setFilterDateFin,
        dateValue: _ctx.dateFin,
        label: _ctx.$t('end.date')
      }, null, 8, ["onSetDate", "dateValue", "label"]),
      _createVNode(_component_ButtonBlue, {
        class: "btn",
        onClick: _ctx.filtrerDates,
        text: _ctx.$t('title.filter')
      }, null, 8, ["onClick", "text"])
    ]),
    (_ctx.isLoading && _ctx.tableData.length === 0)
      ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args))),
          ref: "content",
          class: "table-container"
        }, [
          _createVNode(_component_DataTable, {
            tableData: _ctx.tableData,
            tableHeader: _ctx.tableHeader,
            isLoading: _ctx.isLoading,
            count: _ctx.count,
            "stop-propa-on-pdf": true,
            onSort: _ctx.doModalSort,
            onSelect: _ctx.goToPage,
            onDownloadPdf: _ctx.downloadPdf
          }, null, 8, ["tableData", "tableHeader", "isLoading", "count", "onSort", "onSelect", "onDownloadPdf"])
        ], 544))
  ], 64))
}